import {mergeSxs} from '@hconnect/uikit/src/lib2/utils'
import {SxProps, Theme} from '@mui/material'

export const commonFilterSx: SxProps<Theme> = (theme) => ({
  '& .MuiFilledInput-root': {
    border: 1,
    borderColor: theme.palette.borderHighlight,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.borderHighlight
    },
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.primary.main
    }
  },
  '& .MuiFilledInput-input': {
    color: theme.palette.text.primary,
    padding: '20px 12px 10px'
  },
  '& .MuiFormLabel-root': {
    fontSize: '14px',
    '&.Mui-focused': {
      color: theme.palette.text.secondary
    }
  },
  '& .MuiInputLabel-filled': {
    color: theme.palette.text.secondary
  }
})

export const autocompleteFilterSx: SxProps<Theme> = mergeSxs(commonFilterSx, {
  '& .MuiSelect-icon': {
    color: 'text.primary'
  },
  '& .MuiAutocomplete-tag': {
    color: 'text.primary'
  }
})
